/*
  Content_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { arrayOf, shape, string } from 'prop-types'

import ContentField_v1 from './ContentField_v1'

export default {
  contents: arrayOf(shape(ContentField_v1)),
  title: string,
  format: string,
  id: string,
}
